/* taiga-filter-2026-10-15 (Shopify Store, Filtersystem): Die Zurueck-Taste nimmt den letzten Filterschritt zurueck.
   Hyper schreibt die Filter-URL nur mit history.replaceState; ohne diesen Zusatz fuehrt "Zurueck" aus der Kollektion heraus.
   Laedt nach facets.js (beide defer, Reihenfolge im Abschnitt). Rueckweg: Datei und Script-Tag entfernen.
   taiga-orientierung-2026-10-16: Kontext-Filter in der Schublade (Handy, Tablet). Hyper aktualisiert dort nur Gruppen, die
   schon da waren; neu passende Gruppen (z. B. Messertyp nach Produktart "Küchenmesser") fehlten bis zum Neuladen. Nach jedem
   Filterschritt wird die Schublade deshalb auf genau die Gruppen der neuen Ergebnismenge gebracht (offene Gruppen bleiben offen)
   und die Trefferzahl im Knopf erneuert. */
(() => {
  const FacetForm = customElements.get('facet-form');
  if (!FacetForm || FacetForm.prototype.__taigaHistory) return;
  FacetForm.prototype.__taigaHistory = true;
  let eigeneEintraege = false;
  FacetForm.prototype.updateURLHash = function (url) {
    const ziel = new URL(url, window.location.origin);
    ziel.searchParams.delete('section_id');
    if (ziel.toString() !== window.location.href) {
      history.pushState({ taigaFacet: true }, '', ziel.toString());
      eigeneEintraege = true;
    }
  };
  window.addEventListener('popstate', () => {
    if (!eigeneEintraege && !(history.state && history.state.taigaFacet)) return;
    window.location.replace(window.location.href);
  });

  const schublade = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const neu = doc.querySelector('#DrawerFacetFiltersContainer form');
    const alt = document.querySelector('#DrawerFacetFiltersContainer form');
    if (neu && alt) {
      const soll = Array.from(neu.children).filter((e) => e.matches('[data-filter][data-index]'));
      const indizes = new Set(soll.map((e) => e.getAttribute('data-index')));
      Array.from(alt.children)
        .filter((e) => e.matches('[data-filter][data-index]') && !indizes.has(e.getAttribute('data-index')))
        .forEach((e) => e.remove());
      let vorher = null;
      soll.forEach((n) => {
        const idx = n.getAttribute('data-index');
        let el = Array.from(alt.children).find((e) => e.getAttribute('data-index') === idx);
        if (!el) el = document.importNode(n, true);
        el.classList.remove('hidden');
        const anker = vorher ? vorher.nextSibling : alt.firstChild;
        if (el !== anker) alt.insertBefore(el, anker);
        vorher = el;
      });
      /* taiga-kategorien-2026-10-19: Block ohne data-filter (data-taiga-fixed="first") bleibt erste Gruppe, direkt hinter dem Seiten-Div */
      const fest = alt.querySelector(':scope > [data-taiga-fixed="first"]');
      if (fest) {
        const seite = alt.querySelector(':scope > [data-filter][data-index$="-page"]');
        const ziel = seite ? seite.nextSibling : alt.firstChild;
        if (fest !== ziel) alt.insertBefore(fest, ziel);
      }
    }
    const zahlNeu = doc.querySelector('[data-taiga-anzahl]');
    if (zahlNeu) document.querySelectorAll('[data-taiga-anzahl]').forEach((e) => { e.textContent = zahlNeu.textContent; });
  };
  const anmelden = () => {
    if (!window.FoxTheme || !FoxTheme.pubsub) return false;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, (e) => {
      try { schublade(e.responseText); } catch (err) { /* Hyper-Standardverhalten bleibt */ }
    });
    return true;
  };
  if (!anmelden()) document.addEventListener('DOMContentLoaded', anmelden, { once: true });
})();
